import { render } from "./SectionPage.vue?vue&type=template&id=492106c9&scoped=true"
import script from "./SectionPage.vue?vue&type=script&lang=js"
export * from "./SectionPage.vue?vue&type=script&lang=js"

import "./SectionPage.vue?vue&type=style&index=0&id=492106c9&scoped=true&lang=css"
import "./SectionPage.vue?vue&type=style&index=1&id=492106c9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LewisLi\\workitem\\th workspace\\th_fe\\tiffanyFE-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492106c9"]])

export default __exports__